<template>
	<div class="container site__block">
		<h1 class="text-center">
			German Tote TV
		</h1>
		<p>
			A service provided by Wettstar.
		</p>
	</div>
</template>

<script>
	// @ is an alias to /src

	export default {
		name: 'home',
		components: {
		}
	}
</script>
